export const objToTable = ({
  tableConfig,
  initialColumn,
  lastColumns,
  firstColumns
}: {
  tableConfig?: any[];
  initialColumn: Record<string, any>;
  lastColumns?: any[];
  firstColumns?: any[];
}) => {
  if (tableConfig && tableConfig?.length > 0) {
    return [
      ...(firstColumns || []),
      ...tableConfig?.reduce((p: any[], item) => {
        if (item?.checked && !p?.some(v => v?.key === item?.id)) {
          p.push({ ...initialColumn?.[item?.id], key: item?.id });
        }

        return p;
      }, []),
      ...(lastColumns || [])
    ];
  }
  return [...(firstColumns || []), ...Object.values(initialColumn), ...(lastColumns || [])];
};
